import { useParams } from "react-router-dom";

import Alert from "@rui/Alert";

import MeetingSummaryDownload from "./MeetingSummaryDownload";
import { Container } from "./styles";
import TopicSummaryDownload from "./TopicSummaryDownload";
import TranscriptDownload from "./TranscriptDownload";

const ReportFileDownload = () => {
  const { sessionId, reportType, topicId } = useParams();

  if (topicId) {
    return <TopicSummaryDownload />;
  }

  if (sessionId) {
    if (reportType === "transcript") {
      return <TranscriptDownload />;
    } else if (reportType === "summary") {
      return <MeetingSummaryDownload />;
    }
  }

  return (
    <Container>
      <Alert severity="warning" embedded>
        Unknown file
      </Alert>
    </Container>
  );
};

export default ReportFileDownload;
